import React from 'react';
import { Plus, Heart, MessageCircle, MapPin } from 'lucide-react';

const CheckIns = ({ checkIns, currentUser }) => {
  return (
    <div className="screen">
      <div className="screen-header">
        <h1 className="screen-title">Check-ins</h1>
        <p className="screen-subtitle">Share your nomad journey</p>
      </div>

      {/* User's latest check-in */}
      <div style={{ 
        margin: '0 20px 16px',
        background: 'linear-gradient(135deg, #667eea, #764ba2)',
        borderRadius: '16px',
        padding: '20px',
        color: 'white'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
          <img 
            src={currentUser.avatar} 
            alt={currentUser.name}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid rgba(255, 255, 255, 0.3)'
            }}
          />
          <div>
            <div style={{ fontWeight: '600', fontSize: '16px' }}>
              Share your location
            </div>
            <div style={{ fontSize: '13px', opacity: '0.9' }}>
              Let nomads know where you're working from
            </div>
          </div>
        </div>
        <button style={{
          background: 'rgba(255, 255, 255, 0.2)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '8px',
          color: 'white',
          padding: '10px 16px',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          transition: 'all 0.3s ease'
        }}>
          <MapPin size={16} />
          Check in here
        </button>
      </div>

      {/* Recent Check-ins */}
      <div style={{ 
        padding: '0 20px 8px',
        fontSize: '16px',
        fontWeight: '600',
        color: '#1a1a1a'
      }}>
        Recent Activity
      </div>

      {/* Check-ins List */}
      <div style={{ paddingBottom: '20px' }}>
        {checkIns.map((checkin) => (
          <div key={checkin.id} className="checkin-card">
            <img 
              src={checkin.image} 
              alt={checkin.location}
              className="checkin-image"
            />
            <div className="checkin-content">
              <div className="checkin-location">{checkin.location}</div>
              <div className="checkin-time">{checkin.time}</div>
              <div className="checkin-stats">
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <Heart size={14} />
                  {checkin.likes} likes
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <MessageCircle size={14} />
                  {checkin.comments} comments
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Check-in Button */}
      <button className="add-btn">
        <Plus size={20} />
      </button>
    </div>
  );
};

export default CheckIns;